import { OnlineSessionComponent } from "./../forms/shared-modals/online-session/online-session.component";
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "../../core/helper/auth.guard";
import { SmComponent } from "./sm.component";
import { Component } from "ag-grid";
import { AboutComponent } from "../../about/about.component";
import { AdmisformComponent } from "../../admisform/admisform.component";

const smRoutes: Routes = [

  {
    path: 'about',
    component: AboutComponent,
  },
  {
    path: 'admisform',
    component: AdmisformComponent,
  },
  {
    path: "",
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: SmComponent,
    children: [
      {
        loadChildren: "../forms/home/home.module#HomeModule",
        path: "home",
      },
      {
        loadChildren: "../forms/sms/menuview/menuview.module#MenuviewModule",
        path: "menuview",
      },
      {
        loadChildren:
          "../forms/admin-setup/appsettings/app-settings.module#AppSettingsModule",
        path: "appsettings",
      },

      {
        loadChildren:
          "../forms/academic/TimeManagement/DeviceType/devicetypelist/devicetypelist.module#DevicetypelistModule",
        path: "DeviceType",
      },

      {
        loadChildren:
          "../forms/academic/TimeManagement/Device Registration/deviceregistrationlist/deviceregistrationlist.module#DeviceregistrationlistModule",
        path: "SMMachineRegistration",
      },

      {
        loadChildren:
          "../forms/school-management/CustomShift_detail/customshift_detail.module#CustomShift_detailModule",
        path: "SMCustomshifthdr",
      },

       {
         loadChildren:
           "../forms/ET/policieslist/policieslist.module#PolicieslistModule",
         path: "ETPolicyhdr",
       },
       {
         loadChildren:
           "../forms/ET/leavetypelist/leavetypelist.module#LeavetypelistModule",
         path: "ETLeavetype",
       },
       {
         loadChildren:
           "../forms/ET/schedulelist/schedulelist.module#SchedulelistModule",
         path: "ETSchedulehdr",
       },
       {
         loadChildren:
           "../forms/ET/Calender_Holidays_Detail/CalenderHolidaysDetail.module#CalendarHolidaysDetailModule",
         path: "ETCalholidayDetail",
       },
       {
         loadChildren:
           "../forms/ET/Payroll_Filter/ETPayrollDetail.module#ETPayrollDetailModule",
         path: "ETPayperioddtl",
       },
       {
         loadChildren:
           "../forms/ET/ETShifthdr/ETShifthdr_Filter/ETShifthdr_Filter.module#ETShifthdr_FilterModule",
         path: "ETShifthdr",
       },

       {
         loadChildren:
           "../forms/ET/leavetranslist/leavetranslist.module#LeavetranslistModule",
         path: "ETLeavetran",
       },

       {
         loadChildren:
           "../forms/ET/holidaytype/holidaytypelist/holidaytypelist.module#HolidaytypelistModule",
         path: "ETHolidaytypeList",
       },

       {
         loadChildren:
           "../forms/ET/eppayrollregister/eppayrollregisterlist/eppayrollregisterlist.module#EppayrollregisterlistModule",
         path: "ETPayrollregister",
       },
       {
         loadChildren:
           "../forms/ET/etpayrollsetup/etpayrollsetuplist/etpayrollsetuplist.module#EtpayrollsetuplistModule",
         path: "ETPayrollsetup",
       },

       {
         loadChildren:
           "../forms/ET/ETLeaveadjpolicy/ETLeaveadjpolicy/ETLeaveadjpolicylist.module#ETLeaveAdjustmentPolicylistModule",
         path: "ETLeaveadjpolicy",
       },

       {
         loadChildren:
           "../forms/ET/etleavegroup/etleavegrouplist/etleavegrouplist.module#EtleavegrouplistModule",
         path: "ETLeavegrouphdr",
       },
       {
         loadChildren:
           "../forms/Human-Resource/emp-attendancedaywise/emp-attendancedaywise.module#EmpAttendancedaywiseModule",
         path: "HRBulkAttendance",
       },

       {
         loadChildren:
           "../forms/Human-Resource/employeeattendancenew/employeeattendancenew.module#EmployeeattendancenewModule",
         path: "HRAtnintout",
       },
       {
         loadChildren:
           "../forms/Human-Resource/monthly-empattendance-process/monthly-empattendance-process.module#MonthlyEmpAttendanceProcessModule",
         path: "HRMonthlyAttendance",
       },

       {
         loadChildren:
           "../forms/EP/o-tratepolicyhdr/o-tratepolicyllist/o-tratepolicyllist.module#OTratepolicyllistModule",
         path: "EPOTratepolicyhdr",
       },
       {
         loadChildren:
           "../forms/Time-Management/fetchattendance/fetchattendance.module#FetchattendanceModule",
         path: "HRfetchAttendance",
       },
       {
         loadChildren:
           "./../forms/Human-Resource/payrollslip/payrollslip.module#PayrollslipModule",
         path: "HRpayrollprocess",
       },
       {
         loadChildren:
           "../forms/Human-Resource/daily-attendance-process/daily-attendance-process.module#DailyAttendanceProcessModule",
         path: "HRDailyAttendance",
       },
       {
         loadChildren:
           "../forms/Employee-Profile/Employeeinfohdr/employee-profile-detail/employee-profile-detail.module#EmployeeProfileDetailModule",
         path: "Employeeinfohdr",
       },
       {
         loadChildren:
           "../forms/Employee-Profile/Employeeinfohdr/employee-profile-detail/employee-additional-info/employee-additional-info.module#EmployeeAdditionalInfoModule",
         path: "employee-additional-info",
       },

       {
         loadChildren:
           "../forms/ET/leavequota/leavequotalist/leavequotalist.module#LeavequotalistModule",
         path: "ETLeavequotahdr",
       },
       {
         loadChildren:
           "../forms/EP/transaction/loanissuance/loanissuancelist/loanissuancelistlist.module#LoanIssuancelistModule",
         path: "EPLoantranshdr",
       },
       {
         loadChildren:
           "../forms/ET/leaverequestlist/leaverequestlist.module#LeaverequestlistModule",
         path: "ETLeaveRequest",
       },

       {
         loadChildren:
           "../forms/ET/EPEarninggrphdr/earninggrouplist/earninggrouplistlist.module#EarninggrouplistModule",
         path: "EPEarninggrphdr",
       },
       {
         loadChildren:
           "../forms/EP/EPDeductiongrphdr/deductiongrouplist/deductiongrouplist.module#DeductionGrouplistModule",
         path: "EPDeductiongrphdr",
       },
         {
           loadChildren:
             "../forms/EP/deductiontype/deductiontypelist/deductiontype.module#DeductionTypelistModule",
           path: "EPDeductiontype",
         },
         {
           loadChildren:
             "../forms/EP/loantype/loantypelist/loantypelist.module#LoantypelistModule",
           path: "EPLoantype",
         },
         {
           loadChildren:
             "../forms/EP/loanrequest/loanrequestlist/loanrequestlist.module#LoanrequestlistModule",
           path: "EPLoanrequest",
         },

         {
           loadChildren:
             "../forms/library/setup/author-list/author-list.module#AuthorListModule",
           path: "SMAuthor",
         },
         {
           loadChildren:
             "../forms/organizational-setup/setup/template/templatelist/templatelist.module#TemplatelistModule",
           path: "Smstemplate",
         },
         {
           loadChildren:
             "./../forms/academic/Exam/SM-GPASkill/smgpaskill.module#SMGPASkillModule",
           path: "SMGPASkill",
         },
        {
          loadChildren:
            "./../forms/academic/Exam/SM-Gradescale/GradListing/smgradscal-listing/smgradscal-listing.module#SmgradscalListingModule",
          path: "SMGradescale",
        },
         {
           loadChildren:
             "../forms/school-management/sm-assessmentpolicy/SMAssessmentpolicy-detail/smassessmentpolicy-detail.module#SMAseessmentPolicyDetailModule",
           path: "SMAssessmentPolicyDetail",
         },

         {
           loadChildren:
             "./../forms/academic/Subject/sm-assessmentareahdr/sm-assessmentareahdrlist/sm-assessmentareahdrlist.module#SmAssessmentareahdrlistModule",
           path: "SMAssessmentareahdr",
         },
        {
          loadChildren:
            "../forms/academic/Exam/examtypelisting/examtypelisting.module#ExamtypelistingModule",
          path: "SMExamtype",
        },

         {
           loadChildren:
             "../forms/academic/Exam/sm-exam-register/ExamRegisterListing/examregister-listing/examregister-listing.module#ExamregisterListingModule",
           path: "ExamregisterListing",
         },
         {
           loadChildren:
             "../forms/academic/Exam/SMMarksregisterhdr/SubjectMarkRegister/subjectmarkregister/subjectmarkregister.module#SubjectMarksregisterhdrModule",
           path: "SubjectMarksregisterhdr",
         },
         {
           loadChildren:
             "../forms/academic/Exam/SMMarksregisterhdr/smmarksregisterhdr/smmarksregisterhdr.module#SMMarksregisterhdrModule",
           path: "SMMarksregisterhdr",
         },
         {
           loadChildren:
             "../forms/academic/SM-PromoteStudent/smpromote-student/smpromote-student.module#SMPromoteStudentModule",
           path: "SMPromoteStudent",
         },
         {
           loadChildren:
             "../forms/Communication/Message_Detail/message-detail.module#MessageDetailModule",
           path: "SMMessageDetail",
         },
         {
           loadChildren:
             "../forms/transport-management/setup/color/colorlist/colorlist.module#ColorlistModule",
           path: "Color",
         },
         {
           loadChildren:
             "../forms/transport-management/transaction/driver-registration/driver-registration.module#DriverregistrationModule",
           path: "Driver",
         },
         {
           loadChildren:
             "../forms/transport-management/setup/fueltype/fueltype.module#FuelTypeModule",
           path: "Fueltype",
         },
         {
           loadChildren:
             "../forms/organizational-setup/setup/institute/institutelist/institutelist.module#InstitutelistModule",
           path: "Legalentity",
         },
           {
             loadChildren:
               "../forms/school-management/Admission/guardianlist/guardianlist.module#GuardianlistModule",
             path: "SMGuardian",
           },
           {
             loadChildren:
               "../forms/school-management/transaction/student-profile-detail/student-profile-detail.module#StudentProfileDetailModule",
             path: "Studentinfo",
           },
           {
             loadChildren:
               "../forms/transport-management/setup/route/route.module#RouteModuleMaster",
             path: "Route",
           },
           {
             loadChildren:
               "../forms/academic/CourseAndBatch/SM-Section/smsectionlist/smsectionlist.module#SmsectionlistModule",
             path: "SMSection",
           },
           {
             loadChildren:
               "../forms/organizational-setup/setup/systempolicy/systempolicy.module#SystemPolicyModule",
             path: "Policy",
           },
           {
             loadChildren:
               "../forms/transport-management/transaction/vehicle/vehicle.module#VehicleModuleMaster",
             path: "Vehicle",
           },
           {
             loadChildren:
               "../forms/transport-management/setup/vehicletype/vehicletype.module#VehicleTypeModule",
             path: "Vehicletype",
           },
           {
             loadChildren:
               "../forms/academic/Subject/smlessionplanhdr/SMLlessonplanhdrList/SMLlessonplanhdrList.module#SMLlessonplanhdrListModule",
             path: "SMLessonplanhdr",
           },
           {
             loadChildren:
               "./../forms/academic/Timetable/SM-TimeTable/smtimetable.module#SmtimetableModule",
             path: "SMTimeTable",
           },
           {
             loadChildren:
               "./../forms/academic/Exam/SM-ExamSchedule/smexamschedulehdr.module#SmexamschedulehdrModule",
             path: "SMExamSchedulehdr",
           },
           {
             loadChildren:
               "../forms/organizational-setup/setup/Org-Department/orgdepartmentlist/orgdepartmentlist.module#OrgdepartmentlistModule",
             path: "OrgDepartment",
           },
           {
             loadChildren:
               "../forms/organizational-setup/setup/Org-Religion/orgreligionlist/orgreligionlist.module#OrgreligionlistModule",
             path: "Religion",
           },
           {
             loadChildren:
               "../forms/organizational-setup/setup/Org-Caste/orgcastelist/orgcastelist.module#OrgcastelistModule",
             path: "OrgCaste",
           },
           {
             loadChildren:
               "../forms/school-management/setup/SM-StudentCategory/smstudentcategorylist/smstudentcategorylist.module#SmstudentcategorylistModule",
             path: "SmStudentCat",
           },
           {
             loadChildren:
               "../forms/organizational-setup/setup/Org-Designation/orgdesignationlist/orgdesignationlist.module#OrgdesignationlistModule",
             path: "OrgDesignation",
           },
           {
             loadChildren:
               "../forms/school-management/setup/qualification/qualificationlist/qualificationlist.module#QualificationlistModule",
             path: "ERQualification",
           },
           {
             loadChildren:
               "../forms/school-management/setup/qualification-type/qualificationtypelist/qualificationtypelist.module#QualificationtypelistModule",
             path: "ERQualificationtype",
           },
           {
             loadChildren:
               "../forms/school-management/setup/skilltype/skilltypelist/skilltypelist.module#SkillTypelistModule",
             path: "ERSkilltype",
           },
           {
             loadChildren:
               "../forms/bank-management/setup/bankgroup/bankgrouplist/bankgrouplist.module#BankgrouplistModule",
             path: "FMBankgrp",
           },
           {
             loadChildren:
               "../forms/school-management/setup/positiontype/Positiontypelist/Positiontypelist.module#PositiontypelistModule",
             path: "ERPositiontype",
           },

           {
             loadChildren:
               "../forms/front-office/setup/focomplainttype/focomplainttypelist/focomplainttypelist.module#FOComplainttypelistModule",
             path: "FOComplainttype",
           },
           {
             loadChildren:
               "../forms/front-office/admissionenquiry_filter/admissionenquiry_filter.module#Admissionenquiry_filterModule",
             path: "FOAdmEnquiry_filter",
           },

          {
            loadChildren:
              "../forms/academic/Subject/SM-SubjectAllocation/smsubjectallocation.module#SMSubjectAllocatehdrModule",
            path: "SMSubjectAllocatehdr",
          },

          {
            loadChildren:
              "../forms/library/mediatypelist/mediatypelist.module#MediatypelistModule",
            path: "LMMediatype",
          },
           {
             loadChildren:
               "../forms/library/mediacategorylist/mediacategorylist.module#MediacategorylistModule",
             path: "LMMediacategory",
           },

           {
             loadChildren:
               "../forms/library/publisherlist/publisherlist.module#PublisherlistModule",
             path: "LMPublisher",
           },
           {
             loadChildren:
               "../forms/library/publisherlist/publisherlist.module#PublisherlistModule",
             path: "SMPublisher",
           },
           {
             loadChildren:
               "../forms/library/setup/author/author-list/author-list.module#AuthorListModule",
             path: "LMAuthor",
           },
           {
             loadChildren:
               "../forms/school-management/Pre-Admission/admregistration/applicationgrid/applicationgrid.module#ApplicationgridModule",
             path: "AdmApplication",
           },

           {
             loadChildren:
               "../forms/school-management/student-attendance/studentattendance/studentattendance.module#SMStuAttendanceModule",
             path: "SMStuAttendance",
           },
           {
             loadChildren:
               "../forms/front-office/VisitorBook_Filter/visitorbook_filter.module#Visitorbook_filterModule",
             path: "FOVisitorbook",
           },
           {
             loadChildren:
               "../forms/front-office/CallLog_Filter/calllog_filter.module#Calllog_filterModule",
             path: "FOCalllog",
           },
           {
             loadChildren:
               "../forms/front-office/Complaint_Filter/complaint_filter.module#Complaint_filterModule",
             path: "SMComplaint",
           },
           {
             loadChildren:
               "../forms/membersgrid/membersgrid/membersgrid.module#MembersgridModule",
             path: "LMMembers",
           },
           {
             loadChildren:
               "../forms/library/setup/media-list/media-list.module#MediaListModule",
             path: "LMMedia",
           },
           {
             loadChildren:
               "../forms/library/transaction/Issue/issue.module#issueModuleMaster",
             path: "LMIssueReturn",
           },
           {
             loadChildren:
               "../forms/library/transaction/return/return.module#ReturnModule",
             path: "LMReturn",
           },
           {
             loadChildren:
               "../forms/front-office/PostalDispatch_Filter/postaldispatch_filter.module#PostalDispatch_filterModule",
             path: "FOPostaldispatch",
           },
           {
             loadChildren:
               "../forms/front-office/PostalReceive_Filter/postalreceive_filter.module#PostalReceive_filterModule",
             path: "FOPostalReceived",
           },
           {
             loadChildren:
               "../forms/Communication/PTMRequest_Filter/ptmrequest_Filter.module#Ptmrequest_FilterModule",
             path: "SMPTMrequest",
           },
           {
             loadChildren:
               "../forms/Communication/ptmSchedule/ptm-schedule/ptmschedule-listing/ptmschedule-listing.module#PtmscheduleListingModule",
             path: "SMPTMhdr",
           },
           {
             loadChildren:
               "../forms/school-management/diseases/diseaseslist/diseaseslist.module#DiseaseslistModule",
             path: "SMDiseases",
           },

          {
            loadChildren:
              "../forms/academic/Subject/SMCourseoutlinehdr/SMCourseoutlinehdr.module#CourseoutlineModule",
            path: "SMCourseoutlinehdr",
          },
           {
             loadChildren:
               "../forms/school-management/transaction/student-profile-detail/student-additional-info/student-additional-info.module#StudentAdditionalInfoModule",
             path: "student-additional-info",
           },
           {
             loadChildren:
               "../forms/school-management/setup/studentrollno/studentrollno.module#StudentrollnoModule",
             path: "SMStudentrollno",
           },
           {
             loadChildren:
               "../forms/academic/Questionnaire/questiontypelist/questiontypelist.module#QuestiontypelistModule",
             path: "Questiontype",
           },
           {
             loadChildren:
               "../forms/academic/Questionnaire/questioncategorylist/questioncategorylist.module#QuestioncategorylistModule",
             path: "Questioncategory",
           },
           {
             loadChildren:
               "../forms/academic/Questionnaire/Question-Bank/questionbank.module#QuestionbankModule",
             path: "Questionbank",
           },
           {
             loadChildren:
               "../forms/academic/Questionnaire/questionnairetypelist/questionnairetypelist.module#QuestionnairetypelistModule",
             path: "Questionnairetype",
           },
           {
             loadChildren:
               "../forms/academic/Questionnaire/questionnaire/questionnaire.module#MasterQuestionnaireModule",
             path: "Questionnairehdr",
           },
           {
             loadChildren:
               "../forms/academic/Questionnaire/questionnaire-List/questionnairelist.module#QuestionnairelistModule",
             path: "QuestionnairehdrList",
           },
           {
             loadChildren:
               "../forms/organizational-setup/setup/event-type/eventtypelist/eventtypelist.module#EventtypelistModule",
             path: "OrgEventtype",
           },
           {
             loadChildren:
               "../forms/school-management/leaving/studentleaving/studentleaving.module#StudentleavingModule",
             path: "SMStudentleaving",
           },
           {
             loadChildren:
               "../forms/petty-cash/setup/expensehead/expenseheadlist/expenseheadlist.module#ExpenseheadlistModule",
             path: "FMExpensehead",
           },
           {
             loadChildren:
               "../forms/petty-cash/transaction/expense/expense-list/expense-list.module#ExpenseListModule",
             path: "FMExpensehdr",
           },
           {
             loadChildren:
               "../forms/bank-management/setup/fmbankhdr/fmbankhdrlist/fmbankhdrlist.module#FmbankhdrlistModule",
             path: "FMBankhdr",
           },
           {
             loadChildren:
               "../forms/GL/FIFiscalyearhdr/FIFiscalyearhdr.module#FIFiscalyearhdrModuleMaster",
             path: "FMFiscalhdr",
           },
           {
             loadChildren:
               "../forms/academic/Timetable/periodschedule/SMperiodschedulhdrlist/SMperiodschedulhdrlist.module#PeriodscheduleListModule",
             path: "SMperiodschedulhdr",
           },

           {
             loadChildren:
               "../forms/school-management/setup/qualification/qualificationlist/qualificationlist.module#QualificationlistModule",
             path: "SMQualification",
           },

           {
             loadChildren:
               "./../forms/admin-setup/smholdpolicyhdr/sm-policy-list/sm-policy-list.module#SmPolicyListModule",
             path: "SMHoldpolicyhdr",
           },
           {
             loadChildren:
               "../forms/school-management/setup/qualification-type/qualificationtypelist/qualificationtypelist.module#QualificationtypelistModule",
             path: "SMQualificationtype",
           },
           {
             loadChildren:
               "../forms/school-management/smreasontype/smreasontype.module#SmreasontypeModule",
             path: "SMReasontype",
           },
           {
             loadChildren:
               "../forms/school-management/SMReason/smreason.module#SmreasonModule",
             path: "SMReason",
           },
           {
             loadChildren:
               "../forms/school-management/student-attendance/subjectattendance/subjectattendance.module#SMSubjectattendanceModule",
             path: "SMSubjectattendance",
           },
          {
            loadChildren:
              "../forms/academic/CourseAndBatch/SM-Course/ourse-detail/course-detail/course-detail.module#CourseDetailModule",
            path: "SMCourseDetail",
          },
          {
            loadChildren:
              "../forms/academic/Exam/smexamsyllabus/SMExamsyllabusList/smexamsyllabuslist.module#SmexamsyllabuslistModule",
            path: "SMExamsyllabusList",
          },
           {
             loadChildren:
               "../forms/academic/CourseAndBatch/SM-Batch/smbatch-detail/smbatch-detail.module#SmbatchDetailModule",
             path: "SMBatchDetail",
           },
         {
             loadChildren:
               "./../forms/admin-setup/smholdpolicyhdr/sm-policy-list/sm-policy-list.module#SmPolicyListModule",
             path: "SMHoldpolicyhdr",
           },
           {
             loadChildren:
               "../forms/school-management/setup/qualification-type/qualificationtypelist/qualificationtypelist.module#QualificationtypelistModule",
             path: "SMQualificationtype",
           },
           {
             loadChildren:
               "../forms/school-management/smreasontype/smreasontype.module#SmreasontypeModule",
             path: "SMReasontype",
           },
           {
             loadChildren:
               "../forms/school-management/SMReason/smreason.module#SmreasonModule",
             path: "SMReason",
           },
           {
             loadChildren:
               "../forms/school-management/student-attendance/subjectattendance/subjectattendance.module#SMSubjectattendanceModule",
             path: "SMSubjectattendance",
           },
           {
             loadChildren:
               "../forms/academic/CourseAndBatch/SM-Course/ourse-detail/course-detail/course-detail.module#CourseDetailModule",
             path: "SMCourseDetail",
           },
           {
             loadChildren:
               "../forms/academic/Exam/smexamsyllabus/SMExamsyllabusList/smexamsyllabuslist.module#SmexamsyllabuslistModule",
             path: "SMExamsyllabusList",
           },
           {
             loadChildren:
               "../forms/academic/CourseAndBatch/SM-Batch/smbatch-detail/smbatch-detail.module#SmbatchDetailModule",
             path: "SMBatchDetail",
           },
          {
            loadChildren:
              "../forms/academic/AssigmentAndNotes/SM-Assignment/SMAssignmentlist/smassignmentlist.module#SMAssignmentlistModule",
            path: "SMAssignmentlist",
          },
           {
             loadChildren:
               "../forms/EP/earningtype/earningtypelist/earningtypelist.module#EarningtypelistModule",
             path: "EPEarningtype",
           },

           {
             loadChildren:
               "../forms/academic/AssigmentAndNotes/SM-Assignment/SMTestAssignments/TestList/SMtestlist.module#SMTestListModule",
             path: "SMTestList",
           },

           {
             loadChildren:
               "../forms/academic/Questionnaire/sm-ansgrphdrlist/sm-ansgrphdrlist.module#SmAnsgrphdrlistModule",
             path: "SMAnsgrphdr",
           },

           {
             loadChildren:
               "../forms/GL/FIFiscalcalender/FIFiscalcalender.module#FIFiscalcalenderModule",
             path: "FIFiscalcalender",
           },
           {
             loadChildren:
               "../forms/GL/FIFiscalyearhdr/FIFiscalyearhdr.module#FIFiscalyearhdrModule",
             path: "FIFiscalyearhdr",
           },
          {
            loadChildren:
              "../forms/academic/CourseBooks/SMbook/s-mbooklisting/s-mbooklisting.module#SMbooklistingModule",
            path: "SMBook",
          },
           {
             loadChildren:
               "../forms/academic/Subject/subjectlist/subjectlist.module#SubjectlistModule",
             path: "SMSubject",
           },
          {
            loadChildren:
              "../forms/academic/CourseAndBatch/SM-Course/SMCourseSeection/coursesectionlist/coursesectionlist.module#CoursesectionlistModule",
            path: "SMCourseSectionList",
          },
           {
             loadChildren:
               "../forms/GL/FICharthdr-Detail/FIChartDetailDetail.module#FIChartDetailModule",
             path: "FIChartDetail",
           },
           {
             loadChildren:
               "../Dashboard/attendance-dashboard/attendance-dashboard.module#AttendanceDashboardModule",
             path: "Attendance",
           },
           {
             loadChildren:
               "../forms/academic/AssigmentAndNotes/SMAssignmentTemplateList/smassignmenttemplatelist.module#SMAssignmentTemplateListModule",
             path: "SMAssignmentTemplateList",
           },
           {
             loadChildren:
               "../forms/academic/CourseBooks/documentheading/documentheadinglist/documentheadinglist.module#DocumentheadinglistModule",
             path: "SMDocumentheadingList",
           },
           {
             loadChildren:
               "../forms/academic/AssigmentAndNotes/SMTestTemplateList/smtesttemplatelist.module#SMTestTemplateListModule",
             path: "SMTestTemplateList",
           },
           {
             loadChildren:
               "../forms/organizational-setup/setup/region/regionlist/regionlist.module#RegionlistModule",
             path: "OrgRegion",
           },
           {
             loadChildren:
               "../forms/organizational-setup/setup/site/sitelist/sitelist.module#SitelistModule",
             path: "Orgsite",
           },
           {
             loadChildren:
               "../forms/organizational-setup/setup/Country/countrylist/countrylist.module#CountrylistModule",
             path: "Country",
           },
           {
             loadChildren:
               "../forms/organizational-setup/setup/State/statelist/statelist.module#StatelistModule",
             path: "State",
           },
           {
             loadChildren:
               "../forms/organizational-setup/setup/City/citylist/citylist.module#CitylistModule",
             path: "City",
           },
           {
             loadChildren:
               "../forms/Communication/SMPTMRegisterhdr/smptmregisterhdr.module#SMPTMRegisterhdrModule",
             path: "ptm",
           },
           {
             loadChildren:
               "../forms/Communication/SMPTMRegisterhdrList/smptmregisterhdrlist.module#SMPTMRegisterhdrListModule",
             path: "SMPTMRegisterhdrList",
           },
           {
             loadChildren:
               "../forms/academic/Questionnaire/quiz-info/quiz-info.module#QuizInfoModule",
             path: "SMQuizInfoList",
           },
           {
             loadChildren:
               "../forms/academic/Subject/SMResourcecentre/SMResourcecentre.module#SMResourcecentreModule",
             path: "SMTopicExtendList",
           },
          {
            loadChildren:
              "../forms/academic/Subject/Subject/subjectypelist/subjectypelist.module#SubjectypelistModule",
            path: "SMSubjecttypeDetail",
          },
           {
             loadChildren:
               "../forms/academic/Questionnaire/questionnaire-template-list/questionnaire-template-list.module#QuestionnaireTemplateListModule",
             path: "QuestionnairetemplatehdrList",
           },
           {
             loadChildren:
               "../forms/school-management/transaction/studentwithdrawal/studentwithdrawal.module#StudentwithdrawalModule",
             path: "SMStudentwithdrawal",
           },
           {
             loadChildren:
               "../forms/school-management/Pre-Admission/admissiontest/admissiontest.module#AdmissiontestModule",
             path: "SMAdmApplicationtest",
           },
           {
             loadChildren:
               "../forms/academic/Subject/SMPublishedDocumenthdrList/smpublisheddocumenthdrlist.module#SMPublishedDocumentListModule",
             path: "SMPublishdocumenthdrList",
           },
        {
             loadChildren:
               "../forms/GL/FIFiscalcalender/FIFiscalcalender.module#FIFiscalcalenderModule",
             path: "FIFiscalcalender",
           },
           {
             loadChildren:
               "../forms/GL/FIFiscalyearhdr/FIFiscalyearhdr.module#FIFiscalyearhdrModule",
             path: "FIFiscalyearhdr",
           },
           {
             loadChildren:
               "../forms/academic/CourseBooks/SMbook/s-mbooklisting/s-mbooklisting.module#SMbooklistingModule",
             path: "SMBook",
           },
           {
             loadChildren:
               "../forms/academic/Subject/subjectlist/subjectlist.module#SubjectlistModule",
             path: "SMSubject",
           },
           {
             loadChildren:
               "../forms/academic/CourseAndBatch/SM-Course/SMCourseSeection/coursesectionlist/coursesectionlist.module#CoursesectionlistModule",
             path: "SMCourseSectionList",
           },
           {
             loadChildren:
               "../forms/GL/FICharthdr-Detail/FIChartDetailDetail.module#FIChartDetailModule",
             path: "FIChartDetail",
           },
           {
             loadChildren:
               "../Dashboard/attendance-dashboard/attendance-dashboard.module#AttendanceDashboardModule",
             path: "Attendance",
           },
           {
             loadChildren:
               "../forms/academic/AssigmentAndNotes/SMAssignmentTemplateList/smassignmenttemplatelist.module#SMAssignmentTemplateListModule",
             path: "SMAssignmentTemplateList",
           },
           {
             loadChildren:
               "../forms/academic/CourseBooks/documentheading/documentheadinglist/documentheadinglist.module#DocumentheadinglistModule",
             path: "SMDocumentheadingList",
           },
           {
             loadChildren:
               "../forms/academic/AssigmentAndNotes/SMTestTemplateList/smtesttemplatelist.module#SMTestTemplateListModule",
             path: "SMTestTemplateList",
           },
           {
             loadChildren:
               "../forms/organizational-setup/setup/region/regionlist/regionlist.module#RegionlistModule",
             path: "OrgRegion",
           },
           {
             loadChildren:
               "../forms/organizational-setup/setup/site/sitelist/sitelist.module#SitelistModule",
             path: "Orgsite",
           },
           {
             loadChildren:
               "../forms/organizational-setup/setup/Country/countrylist/countrylist.module#CountrylistModule",
             path: "Country",
           },
           {
             loadChildren:
               "../forms/organizational-setup/setup/State/statelist/statelist.module#StatelistModule",
             path: "State",
           },
           {
             loadChildren:
               "../forms/organizational-setup/setup/City/citylist/citylist.module#CitylistModule",
             path: "City",
           },
           {
             loadChildren:
               "../forms/Communication/SMPTMRegisterhdr/smptmregisterhdr.module#SMPTMRegisterhdrModule",
             path: "ptm",
           },
           {
             loadChildren:
               "../forms/Communication/SMPTMRegisterhdrList/smptmregisterhdrlist.module#SMPTMRegisterhdrListModule",
             path: "SMPTMRegisterhdrList",
           },
           {
             loadChildren:
               "../forms/academic/Questionnaire/quiz-info/quiz-info.module#QuizInfoModule",
             path: "SMQuizInfoList",
           },
           {
             loadChildren:
               "../forms/academic/Subject/SMResourcecentre/SMResourcecentre.module#SMResourcecentreModule",
             path: "SMTopicExtendList",
           },
           {
             loadChildren:
               "../forms/academic/Subject/Subject/subjectypelist/subjectypelist.module#SubjectypelistModule",
             path: "SMSubjecttypeDetail",
           },
           {
             loadChildren:
               "../forms/academic/Questionnaire/questionnaire-template-list/questionnaire-template-list.module#QuestionnaireTemplateListModule",
             path: "QuestionnairetemplatehdrList",
           },
           {
             loadChildren:
               "../forms/school-management/transaction/studentwithdrawal/studentwithdrawal.module#StudentwithdrawalModule",
             path: "SMStudentwithdrawal",
           },
           {
             loadChildren:
               "../forms/school-management/Pre-Admission/admissiontest/admissiontest.module#AdmissiontestModule",
             path: "SMAdmApplicationtest",
           },
           {
             loadChildren:
               "../forms/academic/Subject/SMPublishedDocumenthdrList/smpublisheddocumenthdrlist.module#SMPublishedDocumentListModule",
             path: "SMPublishdocumenthdrList",
           },
          {
             loadChildren:
               "../forms/school-management/Pre-Admission/principalapproval/principalapprovallist/principalapprovallist.module#PrincipalapprovallistModule",
             path: "SMAdmapprovalList",
           },
           {
             loadChildren:
               "../forms/organizational-setup/setup/Yearly_Holiday/SMYearlyholidayList/smyearlyholidaylist.module#SMYearlyholidaylistModule",
             path: "SMYearlyholidaylist",
           },
         {
           loadChildren:
             "../forms/financial-management/transaction/bulkfeechallan/bulkfeechallan.module#BulkFeeChallanModule",
           path: "FeeChallanhdrBulk",
         },     
          {
            loadChildren:
              "../forms/financial-management/transaction/feecollection/feecollection-list/feecollection-list.module#FeecollectionListModule",
            path: "Feecollectionhdr",
          },
           {
             loadChildren:
               "../forms/financial-management/setup/smacademicyear/smacademicyearlist/smacademicyearlist.module#SmacademicyearlistModule",
             path: "SMAcademicYear",
           },
           {
             loadChildren:
               "../forms/financial-management/setup/feewaiverpolicy/feewaiverpolicydetail/feewaiverpolicydetail.module#FeewaiverpolicydetailModule",
             path: "SMFeewaiverpolicy",
           },
           {
             loadChildren:
               "../forms/financial-management/setup/feegroup/feegrouplist/feegrouplist.module#FeegrouplistModule",
             path: "SMFeegrphdr",
           },
           {
             loadChildren:
               "../forms/financial-management/setup/feeprofile/feeprofilelist/feeprofilelist.module#FeeprofilelistModule",
             path: "SMFeeprofhdr",
           },
           {
             loadChildren:
               "../forms/financial-management/setup/feediscount/feediscountlist/feediscountlist.module#FeediscountlistModule",
             path: "SMFeediscount",
           },
           {
             loadChildren:
               "../forms/financial-management/setup/fine-setup/finesetuplist/finesetuplist.module#FinesetuplistModule",
             path: "SMFinesetup",
           },
           {
             loadChildren:
               "../forms/financial-management/setup/feeschedule/feeschedulelist/feeschedulelist.module#FeeschedulelistModule",
             path: "Periodhdr",
           },
           {
             loadChildren:
               "../forms/financial-management/setup/fmfiscalhdr/fmfiscalhdrlist/fmfiscalhdrlist.module#FmfiscalhdrlistModule",
             path: "FMFiscalhdr",
           },
           {
             loadChildren:
               "../forms/financial-management/setup/bulkstudentcocfee/bulkstudentcocfee.module#BulkstudentcocfeeModule",
             path: "SMStudentcocfeeBulk",
           },
           {
             loadChildren:
               "../forms/financial-management/setup/feetype/feetypelist/feetypelist.module#FeetypelistModule",
             path: "Feetype",
           },
       {
         loadChildren:
           "../forms/financial-management/transaction/feechallan/feechallan-list/feechallan-list.module#FeechallanListModule",
         path: "Feechallanhdr",
       },
    
           {
             loadChildren:
               "../forms/financial-management/transaction/bulkchallanvoid/bulkchallanvoid.module#BulkchallanvoidModule",
             path: "FeeChallanVoid",
           },
           {
             loadChildren:
               "../forms/financial-management/setup/smacademicregister/smacademicregisterlist/smacademicregisterlist.module#SmacademicregisterlistModule",
             path: "SMAcademicregister",
           },
           {
             loadChildren:
               "../forms/financial-management/transaction/installmenthdr/installmenthdr.module#InstallmenthdrModule",
             path: "SMInstallmenthdr",
           },
           {
             loadChildren:
               "../forms/financial-management/setup/smadditionalfee/smadditionalfeelist/smadditionalfeelist.module#SmadditionalfeelistModule",
             path: "SMAdditionalFee",
           },
           {
             loadChildren:
               "../forms/GL/FIFiscalyearhdr/FIFiscalyearhdr-Detail/FIFiscalyearhdrDetail.module#FIFiscalyearhdrDetailModule",
             path: "FIFiscalyearDetail",
           },
           {
             loadChildren:
               "../forms/GL/FIDimprofilehdr/FIDimprofilehdr-Detail/FIDimprofilehdrDetail.module#FIDimprofilehdrDetailModule",
             path: "FIDimprofilehdrDetail",
           },
           {
             loadChildren:
               "../forms/GL/FICOA/FICOA-Detail/FICOADetail.module#FICOADetailModule",
             path: "FICOADetail",
           },

           {
             loadChildren:
               "../forms/school-management/Pre-Admission/principalapproval/principalapprovallist/principalapprovallist.module#PrincipalapprovallistModule",
             path: "SMAdmapprovalList",
           },
          {
            loadChildren:
              "../forms/organizational-setup/setup/Yearly_Holiday/SMYearlyholidayList/smyearlyholidaylist.module#SMYearlyholidaylistModule",
            path: "SMYearlyholidaylist",
          },
          {
            loadChildren:
              "../forms/financial-management/transaction/bulkfeechallan/bulkfeechallan.module#BulkFeeChallanModule",
            path: "FeeChallanhdrBulk",
          },
           {
             loadChildren:
               "../forms/financial-management/transaction/feecollection/feecollection-list/feecollection-list.module#FeecollectionListModule",
             path: "Feecollectionhdr",
           },
           {
             loadChildren:
               "../forms/financial-management/setup/smacademicyear/smacademicyearlist/smacademicyearlist.module#SmacademicyearlistModule",
             path: "SMAcademicYear",
           },
           {
             loadChildren:
               "../forms/financial-management/setup/feewaiverpolicy/feewaiverpolicydetail/feewaiverpolicydetail.module#FeewaiverpolicydetailModule",
             path: "SMFeewaiverpolicy",
           },
           {
             loadChildren:
               "../forms/financial-management/setup/feegroup/feegrouplist/feegrouplist.module#FeegrouplistModule",
             path: "SMFeegrphdr",
           },
           {
             loadChildren:
               "../forms/financial-management/setup/feeprofile/feeprofilelist/feeprofilelist.module#FeeprofilelistModule",
             path: "SMFeeprofhdr",
           },
           {
             loadChildren:
               "../forms/financial-management/setup/feediscount/feediscountlist/feediscountlist.module#FeediscountlistModule",
             path: "SMFeediscount",
           },
           {
             loadChildren:
               "../forms/financial-management/setup/fine-setup/finesetuplist/finesetuplist.module#FinesetuplistModule",
             path: "SMFinesetup",
           },
           {
             loadChildren:
               "../forms/financial-management/setup/feeschedule/feeschedulelist/feeschedulelist.module#FeeschedulelistModule",
             path: "Periodhdr",
           },
           {
             loadChildren:
               "../forms/financial-management/setup/fmfiscalhdr/fmfiscalhdrlist/fmfiscalhdrlist.module#FmfiscalhdrlistModule",
             path: "FMFiscalhdr",
           },
           {
             loadChildren:
               "../forms/financial-management/setup/bulkstudentcocfee/bulkstudentcocfee.module#BulkstudentcocfeeModule",
             path: "SMStudentcocfeeBulk",
           },
          {
            loadChildren:
              "../forms/financial-management/setup/feetype/feetypelist/feetypelist.module#FeetypelistModule",
            path: "Feetype",
          },
           {
             loadChildren:
               "../forms/financial-management/transaction/feechallan/feechallan-list/feechallan-list.module#FeechallanListModule",
             path: "Feechallanhdr",
           },
           {
             loadChildren:
               "../forms/financial-management/transaction/bulkchallanvoid/bulkchallanvoid.module#BulkchallanvoidModule",
             path: "FeeChallanVoid",
           },
           {
             loadChildren:
               "../forms/financial-management/setup/smacademicregister/smacademicregisterlist/smacademicregisterlist.module#SmacademicregisterlistModule",
             path: "SMAcademicregister",
           },
          {
            loadChildren:
              "../forms/financial-management/transaction/installmenthdr/installmenthdr.module#InstallmenthdrModule",
            path: "SMInstallmenthdr",
          },
           {
             loadChildren:
               "../forms/financial-management/setup/smadditionalfee/smadditionalfeelist/smadditionalfeelist.module#SmadditionalfeelistModule",
             path: "SMAdditionalFee",
           },
           {
             loadChildren:
               "../forms/GL/FIFiscalyearhdr/FIFiscalyearhdr-Detail/FIFiscalyearhdrDetail.module#FIFiscalyearhdrDetailModule",
             path: "FIFiscalyearDetail",
           },
           {
             loadChildren:
               "../forms/GL/FIDimprofilehdr/FIDimprofilehdr-Detail/FIDimprofilehdrDetail.module#FIDimprofilehdrDetailModule",
             path: "FIDimprofilehdrDetail",
           },
           {
             loadChildren:
               "../forms/GL/FICOA/FICOA-Detail/FICOADetail.module#FICOADetailModule",
             path: "FICOADetail",
           },

           {
             loadChildren:
               "../forms/front-office/StudentLeaveRequest/stdleaverequest.module#StdLeaveRequestModule",
             path: "FOLeaveRequest",
           },
           {
             loadChildren:
               "../forms/library/setup/binlocationlist/location.module#LocationModule",
             path: "LMBinlocation",
           },
           {
             loadChildren:
               "../forms/library/setup/library-list/library-list.module#LibraryListModule",
             path: "LMLibrary",
           },
           {
             loadChildren:
               "../forms/academic/Subject/lessonplan-section/lessonplan-section.module#LessonplanSectionModule",
             path: "SMTopicextendSection",
           },

           {
             loadChildren:
               "../forms/organizational-setup/setup/occupation/occupationlist/occupationlist.module#OccupationlistModule",
             path: "Occupation",
           },
           {
             loadChildren:
               "../forms/GL/FIFiscalcalender/FIFIFiscalcalender-Detail/FIFIFiscalcalenderDetail.module#FIFiscalcalenderDetailModule",
             path: "FIFiscalcalenderDetail",
           },
           {
             loadChildren:
               "../forms/FA/faassetclass/faassetclasslist/faassetclasslist.module#FaassetclasslistModule",
             path: "FAAssetclassList",
           },
           {
             loadChildren:
               "../forms/FA/faassetclass/faassetclass.module#FaassetclassModule",
             path: "FAAssetclass",
           },
           {
             loadChildren:
               "../forms/FA/fadepreciationprofile/fadepreciationprofilelist/fadepreciationprofilelist.module#FadepreciationprofilelistModule",
             path: "FADepreciationprofile",
           },
           {
             loadChildren:
               "../forms/FA/fadepreciationbook/fadepreciationbooklist/fadepreciationbooklist.module#FadepreciationbooklistModule",
             path: "FADepreciationbook",
           },
           {
             loadChildren:
               "../forms/GL/FIExchtype/fi-exctype-detail/fi-exctype-detail.module#FiExctypeDetailModule",
             path: "FIExchtype",
           },
           {
             loadChildren:
               "../Dashboard/revenue-dashboard/revenue-dashboard.module#RevenueDashboardModule",
             path: "Revenue",
           },
           {
             loadChildren:
               "../forms/GL/FICurrencyprofilehdr/fi-currencyprofile-detail/fi-currencyprofile-detail.module#FiCurrencyprofileDetailModule",
             path: "FICurrencyprofilehdr",
           },
           {
             loadChildren:
               "../forms/GL/FILedgerhdr/fi-ledger-detail/fi-ledger-detail.module#FiLedgerDetailModule",
             path: "FILedgerhdr",
           },
           {
             loadChildren:
               "../forms/GL/FIGeneralregister/fi-generalregister-detail/fi-generalregister-detail.module#FiGeneralregisterDetailModule",
             path: "FILedgerregister",
           },
           {
             loadChildren:
               "../forms/GL/FICurrency/fi-currency-detail/fi-currency-detail.module#FiCurrencyDetailModule",
             path: "FICurrency",
           },
           {
             loadChildren:
               "../forms/FA/faassetgrouphdr/fa-assetgroup-detail/fa-assetgroup-detail.module#FaAssetgroupDetailModule",
             path: "FAAssetgroup",
           },
           {
             loadChildren:
               "../forms/GL/FITranshdr/fi-transhdr-list/fi-transhdr-list.module#FiTranshdrListModule",
             path: "FITranshdr",
           },
           {
             loadChildren:
               "../forms/GL/fipostingprofile/fipostingprofilelist/fipostingprofilelist.module#FipostingprofilelistModule",
             path: "FIPostingprofile",
           },
           {
             loadChildren:
               "../forms/FA/faassetcondition/faassetconditionlist/faassetconditionlist.module#FaassetconditionlistModule",
             path: "FAAssetcondition",
           },
           {
             loadChildren:
               "../forms/account-payable/setup/vendortype/vendortypelist/vendortypelist.module#VendortypelistModule",
             path: "APVendortype",
           },
           {
             loadChildren:
               "../forms/account-payable/setup/vendorgroup/vendorgrouplist/vendorgrouplist.module#VendorgrouplistModule",
             path: "APVendorgrp",
           },
           {
             loadChildren:
               "../forms/account-payable/setup/vendor/vendorlist/vendorlist.module#VendorlistModule",
             path: "APVendor",
           },
           {
             loadChildren:
               "../forms/account-payable/setup/entityvendor/entityvendorlist/entityvendorlist.module#EntityvendorlistModule",
             path: "APEntityVendor",
           },
           {
             loadChildren:
               "../forms/account-payable/setup/paymentmethod/paymentmethodlist/paymentmethodlist.module#PaymentmethodlistModule",
             path: "APPaymentmethod",
           },
           {
             loadChildren:
               "../forms/account-payable/setup/paymentterm/paymenttermlist/paymenttermlist.module#PaymenttermlistModule",
             path: "APPaymentterm",
           },
           {
             loadChildren:
               "../forms/account receivable/setup/customergroup/customergrouplist/customergrouplist.module#CustomergrouplistModule",
             path: "ARCustomergrp",
           },
           {
             loadChildren:
               "../forms/account receivable/setup/customertype/customertypelist/customertypelist.module#CustomertypelistModule",
             path: "ARCustomertype",
           },
           {
             loadChildren:
               "../forms/account receivable/setup/customer/customerlist/customerlist.module#CustomerlistModule",
             path: "ARCustomer",
           },
           {
             loadChildren:
               "../forms/item-management/setup/imitemgroup/imitemgrouplist/imitemgrouplist.module#ImitemgrouplistModule",
             path: "IMItemgroup",
           },
           {
             loadChildren:
               "../forms/item-management/setup/imitemsubgroup/imitemsubgrouplist/imitemsubgrouplist.module#ImitemsubgrouplistModule",
             path: "IMItemsubgroup",
           },
           {
             loadChildren:
               "../forms/item-management/setup/immake/immakelist/immakelist.module#ImmakelistModule",
             path: "IMMake",
           },
           {
             loadChildren:
               "../forms/item-management/setup/immodel/immodellist/immodellist.module#ImmodellistModule",
             path: "IMModel",
           },
           {
             loadChildren:
               "../forms/item-management/setup/imaccountingclass/imaccountingclasslist/imaccountingclasslist.module#ImaccountingclasslistModule",
             path: "IMAccountingclass",
           },
           {
             loadChildren:
               "../forms/item-management/setup/imunit/imunitlist/imunitlist.module#ImunitlistModule",
             path: "IMUnit",
           },
           {
             loadChildren:
               "../forms/item-management/setup/imcolor/imcolorlist/imcolorlist.module#ImcolorlistModule",
             path: "IMColor",
           },
           {
             loadChildren:
               "../forms/item-management/setup/imsize/imsizelist/imsizelist.module#ImsizelistModule",
             path: "IMSize",
           },
           {
             loadChildren:
               "../forms/item-management/setup/imstyle/imstylelist/imstylelist.module#ImstylelistModule",
             path: "IMStyle",
           },
           {
             loadChildren:
               "../forms/item-management/setup/imitemvariantgroup/imitemvariantgrouplist/imitemvariantgrouplist.module#ImitemvariantgrouplistModule",
             path: "IMItemvariantgroup",
           },
           {
             loadChildren:
               "../forms/FA/faassetmaster/faassetmasterlist/faassetmasterlist.module#FaassetmasterlistModule",
             path: "FAAssetmaster",
           },
          {
            loadChildren:
              "../forms/academic/Exam/sm-checkpoint-register/CheckPointRegisterListing/checkpontregister-listing/checkpointregister-listing.module#CheckPointListingModule",
            path: "SMCheckPoint",
          },
          {
            loadChildren:
              "../forms/school-management/SMStdSubjectAllocation/smstdsubjectallocation.module#SMStdSubjectAllocationModule",
            path: "SMStdSubjectAllocation",
          },
           {
             loadChildren:
               "../forms/GL/FIPostkey/FIPostkeyDetail/FIPostkeyDetail.module#FiPostkeyDetailModule",
             path: "FIPostkey",
           },
           {
             loadChildren:
               "../forms/FA/fadepreciationprocess/fadepreciationprocesslist/fadepreciationprocesslist.module#FadepreciationprocesslistModule",
             path: "FADepreciationprocess",
           },
           {
             loadChildren:
               "../forms/GL/fipostkeyconfig/fipostkeyconfiglist/fipostkeyconfiglist.module#FipostkeyconfiglistModule",
             path: "FIPostKeyConfig",
           },
           {
             loadChildren:
               "../forms/Human-Resource/skillrating/skillratinglist/skillratinglist.module#SkillratinglistModule",
             path: "ERSkillratinghdr",
           },
           {
             loadChildren:
               "../Dashboard/exam-dashboard/exam-dashboard.module#ExamDashboardModule",
             path: "ExamDashboard",
           },
          {
             loadChildren:
               "../Dashboard/campus-dashboard/campus-dashboard.module#CampusDashboardModule",
             path: "CampusDashboard",
           },
           {
             loadChildren:
               "../forms/school-management/setup/skill/skilllist/skilllist.module#SkillListModule",
             path: "ERSkill",
           },
           {
             loadChildren:
               "../forms/FA/faassetacquisition/faassetacquisitionlist/faassetacquisitionlist.module#FaassetacquisitionlistModule",
             path: "FAAssetacquisition",
           },

           {
             loadChildren:
               "../forms/school-management/transaction/student-profile-detail/smstudentcocfeelist/smstudentcocfeelist.module#SmstudentcocfeelistModule",
             path: "SMStudentcocfee",
           },
           {
             loadChildren:
               "../forms/financial-management/setup/bulkstudentcocfee/bulkstudentcocfee.module#BulkstudentcocfeeModule",
             path: "SMStudentcocfeeBulk",
           },
           {
             loadChildren:
               "../forms/Employee-Profile/Employeeinfohdr/employee-salary/employee-salary.module#EmployeeSalaryModule",
             path: "EREmpsalarydtl",
           },
           {
             loadChildren:
               "../forms/Human-Resource/Setup/cardtype/cardtypelist/cardtypelist.module#CardtypelistModule",
             path: "EREmpCardType",
           },
           {
             loadChildren:
               "../forms/organizational-setup/setup/campusattendance/campusattendance.module#CampusattendanceModule",
             path: "OrgCampusAttendance",
           },
           {
             loadChildren:
               "../forms/academic/CourseAndBatch/coursecoverage/coursecoverage.module#CoursecoverageModule",
             path: "SMTopiclog",
           },
           {
             loadChildren:
               "../forms/account receivable/setup/royalitygroup/royalitygrouplist/royalitygrouplist.module#RoyalitygrouplistModule",
             path: "ARRoyaltygrphdr",
           },
           {
             loadChildren:
               "../forms/petty-cash/setup/expenseheadmap/expenseheadmap.module#ExpenseheadmapModule",
             path: "FMExpheadcoa",
           },
           {
             loadChildren:
               "../forms/Human-Resource/emp-authoritylisting/emp-authoritylisting.module#EmpAuthoritylistingModule",
             path: "EREmpAuthority",
           },
           {
             loadChildren:
               "../forms/account receivable/setup/royality-agreement/royality-agreement-list/royality-agreement-list.module#RoyalityAgreementListModule",
             path: "ARRoyaltyagreementhdr",
           },

           {
             loadChildren:
               "../forms/petty-cash/transaction/pettycashrequest/pettycashrequestlist/pettycashrequestlist.module#PettycashrequestlistModule",
             path: "FIPCRequesthdr",
           },
           {
             loadChildren:
               "../forms/account receivable/setup/entitycustomer/entitycustomerlist/entitycustomerlist.module#EntitycustomerlistModule",
             path: "AREntitycustomer",
           },

           {
             loadChildren:
               "../forms/front-office/setup/purpose/purpose-list/purpose-list.module#PurposeListModule",
             path: "FOPurpose",
           },

           {
             loadChildren:
               "../forms/front-office/setup/fosourcetype/fosourcetypelist/fosourcetypelist.module#FosourcetypelistModule",
             path: "FOSourcetype",
           },

           {
             loadChildren:
               "../forms/school-management/SMSudentleave/sm-studleavelist/sm-studleavelist.module#SmStudleavelistModule",
             path: "SMStudentleave",
           },
           {
             loadChildren:
               "../forms/library/mediacategorylist/mediacategorylist.module#MediacategorylistModule",
             path: "SMBookCategory",
           },

           {
             loadChildren:
               "../forms/academic/Certificate/certificatetype/certificatetypelist/certificatetypelist.module#CertificatetypelistModule",
             path: "SMCertificatetype",
           },

           {
             loadChildren:
               "../forms/academic/Certificate/certificaterequest/certificaterequestlist/certificaterequestlist.module#CertificaterequestlistModule",
             path: "SMCertificatrequesthdr",
           },

          {
            loadChildren:
              "../forms/academic/CourseAndBatch/SM-Section-Group/section-group-list/section-group-list.module#SectionGroupListModule",
            path: "SMSectionGroup",
          },
           {
             loadChildren:
               "../forms/academic/Subject/SMDocumentType/document-typelist/document-typelist.module#DocumentTypelistModule",
             path: "SMDocumentType",
           },
          {
            loadChildren:
              "../Dashboard/head-off-dashboard/head-off-dashboard.module#HeadOffDashboardModule",
            path: "HeadOfficeDashboard",
          },
           {
             loadChildren:
               "../forms/Project Management/Setup/resourcetype/resource-type-list/resource-type-list.module#ResourceTypeListModule",
             path: "PSResourcetype",
           },
           {
             loadChildren:
               "../forms/account receivable/transaction/artranshdr/artranshdrlist/artranshdrlist.module#ArtranshdrlistModule",
             path: "ARTranshdr",
           },
           {
             loadChildren:
               "../forms/academic/Certificate/Certificate_Template/SMCertificatetemp.module#SMCertificatetempModule",
             path: "Certificatetemp",
           },

           {
             loadChildren:
               "../forms/academic/Timetable/sm-period/smperiodlist/smperiodlist.module#SmperiodlistModule",
             path: "SMPeriod",
           },
          {
            loadChildren:
              "../forms/library/setup/author/author-list/author-list.module#AuthorListModule",
            path: "SMAuthor",
          },
           {
             loadChildren:
               "../forms/Human-Resource/Setup/HRDocType/HRDocTypelist/HRDocTypelist.module#HRDocumentTypelistModule",
             path: "HRDocType",
           },

           {
             loadChildren:
               "../forms/StudentManagement/transfer-request-list/transfer-request-list.module#TransferRequestListModule",
             path: "Studenttransfer",
           },
           {
             loadChildren:
               "../forms/StudentManagement/transfer-approval/transfer-approval.module#TransferApprovalModule",
             path: "TransferApproval",
           },
           {
            loadChildren:
              "../forms/StudentManagement/bulk-transfer/bulk-transfer.module#BulkTransferModule",
            path: "SMBulkStudenttransfer",
          },
           {
             loadChildren:
               "../forms/Inventory/aisle/aislelisting/aislelisting.module#AislelistingModule",
             path: "OrgAisle",
           },
           {
             loadChildren:
               "../forms/Inventory/storearea/storeaealisting/storeaealisting.module#StoreaealistingModule",
             path: "OrgStorearea",
           },
           {
             loadChildren:
               "../forms/Inventory/inventorylocation/inventorylocationlisting/inventorylocationlisting.module#InventorylocationlistingModule",
             path: "OrgInventorylocation",
           },
           {
             loadChildren:
               "../forms/Inventory/warehouse/warehouselisting/warehouselisting.module#WarehouselistingModule",
             path: "OrgWarehouse",
           },
           {
             loadChildren:
               "../forms/item-management/setup/imitempolicy/imitempolicylisting/imitempolicylisting.module#ImitempolicylistingModule",
             path: "IMItempolicy",
           },
           {
             loadChildren:
               "../forms/item-management/setup/imstoragedimension/imstoragedimension-listing/imstoragedimension-listing.module#ImstoragedimensionListingModule",
             path: "IMStorageDimhdr",
           },
           {
             loadChildren:
               "../forms/item-management/setup/trackingdimension/trackingdimensionlisting/trackingdimensionlisting.module#TrackingdimensionlistingModule",
             path: "IMTrackDimhdr",
           },
           {
             loadChildren:
               "../forms/item-management/setup/itemchart/itemchartlisting/itemchartlisting.module#ItemchartlistingModule",
             path: "IMItemchart",
           },
           {
             loadChildren:
               "../forms/item-management/setup/itemregister/itemregisterlisting/itemregisterlisting.module#ItemregisterlistingModule",
             path: "IMItemregister",
           },

           {
             loadChildren:
               "../forms/Inventory/item/itemlisting/itemlisting.module#ItemlistingModule",
             path: "IMItem",
           },
           {
             loadChildren:
               "../forms/Inventory/itemrequestion/itemrequestlist/itemrequestlist.module#ItemrequestlistModule",
             path: "IMItemreqhdr",
           },
           {
             loadChildren:
               "../forms/Project Management/Setup/category/categorylist/categorylist.module#CategorylistModule",
             path: "PSCategory",
           },

           {
             loadChildren:
               "../forms/Project Management/Setup/categorygroup/categorygrouplist/categorygrouplist.module#CategorygrouplistModule",
             path: "PSCatgroup",
           },
           {
             loadChildren:
               "../forms/Inventory/purchaserequistion/purchaserequistionlist/purchaserequistionlist.module#PurchaserequistionlistModule",
             path: "PMPurchasereqhdr",
           },
           {
             loadChildren:
               "../forms/Project Management/Setup/psindirectcost/psindirectcostlist/psindirectcostlist.module#PsindirectcostlistModule",
             path: "PSIndirectcost",
           },
           {
             loadChildren:
               "../forms/Project Management/Setup/projectgroup/projectgrouplist/projectgrouplist.module#ProjectgrouplistModule",
             path: "PSProjectgrp",
           },
           {
             loadChildren:
               "../forms/organizational-setup/setup/room/roomlist/roomlist.module#RoomlistModule",
             path: "OrgRoom",
           },
          {
            loadChildren:
              "./../forms/academic/Exam/final-result-compilation/final-result-compilation.module#FinalResultCompilationModule",
            path: "SMfinalresultcompilation",
          },
           {
             loadChildren:
               "../forms/Project Management/Setup/resource/resource-list/resource-list.module#ResourceListModule",
             path: "PSResource",
           },

           {
             loadChildren:
               "../forms/admin-setup/document/document.module#DocumentModule",
             path: "SMDocument",
           },

           {
             loadChildren:
               "../forms/organizational-setup/setup/building/buildinglist/buildinglist.module#BuildinglistModule",
             path: "OrgBuilding",
           },
           {
             loadChildren:
               "../forms/organizational-setup/setup/Floor/floorlist/floorlist.module#FloorlistModule",
             path: "OrgFloor",
           },

           {
             loadChildren:
               "../forms/ET/emp-attendanceactivity/emp_attendanceactivity.module#EmpAttendanceActivityModule",
             path: "HRAtnactivity",
           },

           {
             loadChildren:
               "../forms/financial-management/setup/bulkstudentdiscount/bulkstudentdiscount.module#BulkstudentdiscountModule",
             path: "SMStudentdiscount",
           },

           {
             loadChildren:
               "../forms/academic/Subject/Teacher'sSubjectrating/teachersubjectrating.module#TeacherSubjectRatingModule",
             path: "Teachersubjectrating",
           },

          {
            loadChildren:
              "../forms/Communication/Meeting/schedule-meeting/schedule-meetinglist/schedule-meetinglist.module#ScheduleMeetinglistModule",
            path: "SMSchedulemeetinghdr",
          },
           {
             loadChildren:
               "../forms/Communication/joinmeeting/joinmeeting/joinmeeting.module#JoinmeetingModule",
             path: "joinmeeting",
           },
           {
             loadChildren:
               "../forms/academic/Subject/topic-delivery/topic-delivery.module#TopicDeliveryModule",
             path: "TopicDelivery",
           },

           {
             loadChildren:
               "../forms/organizational-setup/setup/additionalinformation/additionalinformation.module#AdditionalinformationModule",
             path: "OrgAdditionalInformation",
           },
           {
             loadChildren:
               "../forms/account receivable/transaction/artranshdr_cc/artranshdr_cclist/artranshdr_cclist.module#artranshdr_cclistModule",
             path: "190202ARTranshdr",
           },
           {
             loadChildren:
               "../forms/admin-setup/unblockactivity/unblockactivitylist/unblockactivitylist.module#UnblockactivitylistModule",
             path: "SMUnblockactivity",
           },

           {
             loadChildren:
               "../forms/organizational-setup/setup/data-setup/data-setup.module#DataSetupModule",
             path: "OrgSchoolSetup",
           },
           {
             loadChildren:
               "../forms/account receivable/transaction/artranshdr_customerpayment/artranshdr_customerpaymentlist/artranshdr_customerpaymentlist.module#artranshdr_customerpaymentlistModule",
             path: "190203ARTranshdr",
           },
           {
             loadChildren:
               "../forms/ET/upload-attendance/upload-attendance.module#UploadAttendanceModule",
             path: "UploadAttendance",
           },
          {
            path: 'OrgDataSetup',
            loadChildren: '../forms/organizational-setup/setup/data-setup/data-setup.module#DataSetupModule'
          },
          {
            path: 'FICOA_new',
            loadChildren: '../forms/GL/ficoa-new/FICOA_NEW.module#FICOA_NEWModule'
          },
          {
            path: 'FIBookType',
            loadChildren: '../forms/financial-management/setup/FIbook_type/FIbook_typelist/FIbook_typelist.module#FIbook_typelistModule'
          },
          {
            path: 'FIAccountnature',
            loadChildren: '../forms/financial-management/setup/FIAcoountnature/FIAccountnaturelist/FIAccountnaturelist.module#FIAccountnaturelistModule'
          },
          {
            path: 'FIPartyType',
            loadChildren: '../forms/financial-management/setup/FIpartytype/FIpartytypelist/FIpartytypelist.module#FIpartytypelistModule'
          },
          {
            path: 'FIAccountType',
            loadChildren: '../forms/financial-management/setup/FIAccount_type/FIAccount_typelist/FIAccount_typelist.module#FIAccountTypelistModule'
          },
          {
            path: 'FIFiscalYear',
            loadChildren: '../forms/financial-management/setup/FIFiscalYear/FIFiscalYearlist/FIFiscalYearlist.module#FIFiscalYearlistModule'
          },
          {
            path: 'FIMiscType',
            loadChildren: '../forms/financial-management/setup/FIMiscType/FIMiscType.module#FIMiscTypeModule'
          },
          {
            path: 'FIBankSetup',
            loadChildren: '../forms/financial-management/setup/fibanksetup/fibanksetuplist/fibanksetuplist.module#FibanksetuplistModule'
          },
          {
            path: 'FIBankaccountsetup',
            loadChildren: '../forms/financial-management/setup/fibankaccount-setup/fibankaccount-setuplist/fibankaccount-setuplist.module#bankaccountlistModule'
          },
          {
            path: 'FIPaymentVoucher',
            loadChildren: '../forms/financial-management/setup/FIPaymentVoucher/FIPaymentVoucherlist/FIPaymentVoucherlist.module#FIPaymentVoucherlistModule'
          },

         {
            path: 'FIJournalVoucher',
            loadChildren: '../forms/financial-management/transaction/FIJournalVoucher/FIJournalVoucherlist/FIJournalVoucherlist.module#FIJournalVoucherlistModule'
          },

          {
            path: 'FICurrencyNew',
            loadChildren: '../forms/financial-management/setup/currency/currencyList/currencyList.module#currencyListModule'

          },

          {
            path: 'EREmppayroll',
            loadChildren: '../forms/Employee-Profile/Employeeinfohdr/emppayroll/eremppayroll.module#EmpPayrollModule'
          },
            {
            path: 'FICashbook',
            loadChildren: '../forms/financial-management/transaction/CashBook/cash-booklist/cash-booklist.module#cashbooklistModule' 
          }, 
          {
            path: 'FIReceiptVoucher',
            loadChildren: './../forms/financial-management/transaction/ReceiptVoucher/ReceiptVoucherlist/receiptvoucherlist.module#receiptvoucherlistmodule' 
          }, 
          {
            loadChildren:
              "../Dashboard/finance-dashboard/finance-dashboard.module#FinanceDashboardModule",
            path: "FIDashboard",
          },
          {
            path: 'OrgDonor',
            loadChildren: '../forms/organizational-setup/setup/donor-discount/donorlist/donorlist.module#donorlistModule'
          },
      {
        path: 'PMPurchaseorderhdr',
        loadChildren: '../forms/Inventory/transaction/purchase-order/purchase-order-list/purchase-order-list.module#PurchaseOrderListModule'
      },

      {
        path: 'PMGoodsReceivednotehdr',
        loadChildren: '../forms/Inventory/transaction/goods-receive-note/grn-list/grn.module#GrnModule'
      },
      {
        path: 'IMItemTransfer',
        loadChildren: '../forms/Inventory/transaction/inventory-transfer/inventory-transfer-list/inventory-transfer-list.module#InventoryTransferListModule'
      },
      {
        path: 'PMSalesrec',
        loadChildren: '../forms/Inventory/transaction/sale-receipt/sale-receipt-list/sales-receipt-list.module#SalesReceiptListModule'
      },
      {
        path: 'PMSaleshdr',
        loadChildren: '../forms/Inventory/transaction/sales-invoice/sales-invoice-list/sales-invoice-list.module#SalesInvoiceListModule'
      },
      {
        path: 'PMCreditNoteCashouthdr',
        loadChildren: '../forms/Inventory/transaction/credit-note-cashout/creditNoteCashout-list/creditNoteCashout-list.module#creditNoteCashoutListModule'
      },
      {
        path: 'PMSalesReturnhdr',
        loadChildren: '../forms/Inventory/transaction/sales-return/sales-return-list/sales-return-list.module#SalesReturnListModule'
      },
      {
        path: 'PMCreditNote',
        loadChildren: '../forms/Inventory/transaction/sale-receipt-creditnote/sale-receipt-list-creditnote/sales-receipt-list-creditnote.module#SalesReceiptListCreditNoteModule'
      },
      {
        path: 'PMPurchasehdr',
        loadChildren: '../forms/Inventory/transaction/purchase-invoice/purchase-invoice-list/purchase-invoice-list.module#PurchaseInvoiceListModule'
      },
      {
        path: 'PMPurchasenonhdr',
        loadChildren: '../forms/Inventory/transaction/purchase-noninventory-invoice/purchase-noninventory-invoice-list/purchase-noninventory-invoice-list.module#PurchaseNonInventoryInvoiceListModule'
      },
      {
        loadChildren:
          "../forms/Inventory/vendorbillpayment/VBPaymentVoucher-listing/VBPaymentVoucherlist.module#VBPaymentVoucherlistModule",
        path: "Vendorbillpayment",
      },



    ],
  },
  {
    component: OnlineSessionComponent,
    path: "online-session",
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(smRoutes)],
  exports: [RouterModule]
})
export class SmRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/shell/sm/sm.routing.ts